'use client';

import React from 'react';
import { LoaderCircle } from 'lucide-react';
import { useTranslations } from '@/lib/locale-context';

const SubmittingState: React.FC = () => {
  const { t } = useTranslations();

  return (
    <div className="mx-auto flex w-full max-w-md flex-col items-center text-center">
      <div className="flex h-12 w-12 items-center justify-center">
        <LoaderCircle
          className="h-10 w-10 animate-spin text-brand-700"
          aria-label="Loading"
        />
      </div>
      <p className="mt-4 text-[14px] text-[#666D80]">
        {t('gatewayForms.pleaseWait')}
      </p>
    </div>
  );
};

export default SubmittingState;
